/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import HomeroomsIcon from 'icons/HomeroomsIcon';

const messages = defineMessages({
  title: {id: 'navigation.homerooms'},
});

const HomeroomsItem = () => (
  <RouteLinkItem
    iconBefore={HomeroomsIcon}
    route="midas/students/homerooms"
    title={messages.title}
  />
);

export default HomeroomsItem;
